module.exports = __webpack_public_path__ + "OurVisiofor5G_2.jpg?76ac7cddc6dd033b5ef5e915c202ea79";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/OurVisiofor5G_2.jpg
// module id = 191
// module chunks = 0